import $ from 'jquery';
import 'masonry-layout';

class MasonryLoader {
	constructor() {
		this.events();
	}

	events() {
	    $('.masonry').masonry({
	        itemSelector: '.masonry-item'
	    });

	    $('.masonry').find('img').load(function() {
	        $('.masonry').masonry('reloadItems').masonry('layout');
	    });

	    $(document).ajaxComplete(function() {
	        $('.masonry').masonry();

	        $('.masonry').find('img').load(function() {
	            $('.masonry').masonry('reloadItems').masonry('layout');
	        });
	    });
	}
}

export default {
	init () {
		if ($('.masonry').length) {
			new MasonryLoader();
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/masonryLoader.js